import React, { Component } from 'react';
import _ from 'lodash';
import pluralize from 'pluralize';
import titleize from 'titleize';
import NgssTagGroup from './NgssTagGroup';
import '../assets/css/components/popups.css';
import '../assets/css/components/assignment-popup.css';

const ActivityPopup = ({ activity, handleClose }) => {
  const ngssContentCount = (()=> {
    if(!activity){ return 0 }
    return _.isEmpty(activity) ? 0 : _.flatten([activity['ngss-seps'], activity['ngss-dcis'], activity['ngss-cccs'], activity['ngss-pes']]).length;
  })();

  const getContentType = ()=>titleize(pluralize.singular(activity.type))

  return(
    <div className='assignment-popup popup-content popup dialog responsive-popup dialog--open'>
      <div onClick={handleClose} className='popup-background'></div>
      {activity &&
        <div className="dialog__content">
          <div className="container-fluid">
            <div className="dialog__overview">
              <div id="standard-col" className="col-md-6 p-r-35 p-t-35 p-l-35 item-description bg-immersed-primary">
                <span className="label font-montserrat fs-11 card-type">Standards</span><br/><br/>
                <h2 className="semi-bold no-margin font-montserrat text-white" id="activity-name">NGSS Standards</h2>
                <br/>
                {ngssContentCount === 0 &&
                  <b><p className="fs-13 text-white">There's no NGSS content associated with this activity.</p></b>
                }
                {ngssContentCount !== 0 &&
                  <NgssTagGroup objectWithNgssTags={activity} size='small'/>
                }
                <br/><br/>
              </div>
              <div id="activity-col" className="col-md-6 p-r-35 p-t-35 p-l-35 item-description">
                <span className="label font-montserrat fs-11">Activity</span><br/><br/>
                <div className="tab-content">
                  <div className="tab-pane active" id="tab-fillup1">
                    {/*<h2 className="semi-bold no-margin font-montserrat" id="standard-title">Assign <span className='card-type'>Quest</span></h2>*/}
                    <div id='assignment-form-wrapper'>
                      <div className='empty-classes-notice'>
                        <h2>{activity.title}</h2>
                      </div>

                      <br/>
                      <p>{activity.description}</p>
                      <br/>
                      <div className='activity-button'>
                        <a className='btn btn-success btn-activity' target='_blank' href={activity.driveLink}>Open Activity</a>
                      </div>
                      <br/>
                    </div>

                    <br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button onClick={handleClose} className="popup-close close action top-right" data-dialog-close=""><i className="fa fa-times"></i></button>
        </div>
      }
    </div>
  );
}

export default ActivityPopup;
